import DOMPurify from 'dompurify';

// Judges see the competition's `evaluation` HTML with only these tags and attributes.
const PROMPT_SANITIZE_CONFIG = {
  ALLOWED_TAGS: ['strong', 'b', 'em', 'i', 'u', 'br', 'span', 'p', 'ul', 'ol', 'li', 'a'],
  ALLOWED_ATTR: ['href', 'target', 'rel'],
};

export function sanitizeEvaluationPromptHtml(html: string): string {
  return String(DOMPurify.sanitize(html, PROMPT_SANITIZE_CONFIG));
}
